<template>
    <div class="flex gap-3">
        <div class="w-1/3 flex flex-col gap-3">
            <Card class="mb-[9px]">
                <template #title class="w-full">
                    {{ $root.trans.informazioni_ordine }}
                </template>
                <template #content class="w-full flex gap-3">
                    <ul>
                        <li>
                            <b>{{ $root.trans.ragione_sociale }}</b>
                            <span class="ml-3">
                                {{ fornitore.ragione_sociale }}
                            </span>
                        </li>
                        <li>
                            <b>{{ $root.trans.numero_ordine }}</b>
                            <span class="ml-3">
                                {{ ordine.numeratore }}
                            </span>
                        </li>
                        <li>
                            <b>{{ $root.trans.data_arrivo }}</b>
                            <span class="ml-3">
                                {{ ordine.data }}
                            </span>
                        </li>
                    </ul>
                </template>
            </Card>
            <Card>
                <template #title class="w-full">
                    {{ $root.trans.conferma_con_barcode }}
                </template>
                <template #content class="w-full">
                    <FloatLabel class="w-full" variant="on">
                        <AutoComplete v-model="barcode" forceSelection optionLabel="nome" ref="autocomplete" :suggestions="productSuggestion" @complete="cercaCodice" id="barcode" @option-select="caricaProdotto"/>
                        <label for="barcode"> {{ $root.trans.cerca_codice_a_barre }} </label>
                    </FloatLabel>
                    <FloatLabel class="w-full" variant="on">
                        <Select 
                            v-model="ordine.stato" 
                            id="stato" 
                            :options="[{label: $root.trans.stato_ordine_in_lavorazione, value: '1'}, {label: $root.trans.stato_ordine_finito, value: '2'}, {label:  $root.trans.stato_ordine_finito_con_assenza, value: '3'}]" 
                            placeholder="Stato" 
                            optionLabel="label"
                            optionValue="value"
                            />
                        <label for="stato"> {{ $root.trans.stato_ordine }} </label>
                    </FloatLabel>
                    <Button @click="salva" class="p-button p-component p-button-success mt-3">
                        {{ $root.trans.salva }}
                    </Button>


                </template>
            </Card>

            <Card>
                <template #title class="w-full">
                    {{ $root.trans.prodotti_confermati }}
                </template>
                <template #content class="w-full">
                   <ul class="overflow-y-auto max-h-[30vh]">
                        <li v-for="(prodotto, index) in selectedProducts" :key="index">
                            <span class="ml-3">
                                {{ prodotto.nome }} x {{ prodotto.quantita_riportata }}
                            </span>
                        </li>
                   </ul>
                </template>
            </Card>
        </div>
        <div class="w-2/3">
    
            <Card >
                <template #title class="w-full">
                    {{ $root.trans.prodotti_ordine }}
                </template>
                <template #content class="w-full flex gap-3">
                    <div class="h-[50vh] overflow-y-scroll">
                        <table class="w-full">
                            <thead class="z-50">
                                <tr>
                                    <th class="fs-5" style="position: sticky; top: 0; background: white;">Sku</th>
                                    <th class="fs-5" style="position: sticky; top: 0; background: white;">Nome</th>
                                    <th class="fs-5" style="position: sticky; top: 0; background: white;">Quantità</th>
                                    <th class="fs-5" style="position: sticky; top: 0; background: white;">Confermato</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(prodotto, index) in prodotti" :key="index" class="py-2" :class="prodotto.confermato == 1 ? 'bg-green-900' : ''">
                                    <td>{{ prodotto.barcode }}</td>
                                    <td>{{ prodotto.nome }}</td>
                                    <td>
                                        {{ prodotto.quantita_riportata }}
                                    </td>
                                    <td>
                                        <Checkbox v-model="prodotto.confermato" binary @change=""/>
                                    </td>
        
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </template>
            </Card>
        </div>
    </div>
    
</template>
  
<script>
  
    import InputText from 'primevue/inputtext';
    import FloatLabel from 'primevue/floatlabel';
    import Button from 'primevue/button';
    import  AutoComplete  from 'primevue/autocomplete';
    import Checkbox from 'primevue/checkbox';
    import  Select  from 'primevue/select';

  
    export default {
        name: "VerificaOrdine",
        components: {
            InputText,
            FloatLabel,
            Button,
            AutoComplete,
            Checkbox,
            Select,
        },
        props: ['dati_ordine','prodotti_ordine','dati_fornitore','action'],
        data() {
            return {
                fornitore: this.dati_fornitore,
                ordine: this.dati_ordine,
                prodotti: this.prodotti_ordine,
                action: this.action,
                barcode: '',
                productSuggestion: [],
                stato:1
            };
        },
        computed: {
            selectedProducts() {
                return this.prodotti.filter((item) => {
                    return item.confermato == 1;
                });
            },
        },
        methods: {
            cercaCodice(e){
                if (!e.query.trim().length) {
                    this.productSuggestion = [...options];
                } else{
                    this.productSuggestion = this.prodotti.filter((item) => {
                        return item.barcode && item.barcode.toLowerCase().includes(e.query.toLowerCase());
                    });
                }

                if(this.productSuggestion.length == 1){
                    this.productSuggestion[0].confermato = true;
                    this.barcode = ''
                }
            },
            salva(){
                const confirmedProducts = this.prodotti.filter((item) => {
                    return item.confermato == 1;
                }).map((el)=>el.id);


                const data = {
                    ordine: this.ordine,
                    prodotti_confermati: confirmedProducts,
                }
                axios.post(this.action,data).then((res)=>{
                    console.log(res.data);
                    if (res.data.success) {
							this.$toast.add({
								severity: 'success',
								summary: this.$root.trans.success_form,
								detail: this.$root.trans.salvataggio_success,
								life: 3000
							});
                        if (res.data.params) {
                            window.location.href = route(res.data.redirect, res.data.params);
                        } else {
                            window.location.href = route(res.data.redirect);
                        }
                    }
                })
            }
        }
    }
</script>

<style scoped>

</style>